import "./Outline.scss";

function Outline() {
  const sections = [
    { level: "h2", title: "Intro", target: "Intro" },
    { level: "h2", title: "Feature Extraction", target: "FeatureExtraction" },
    { level: "h3", title: "Training Enhancements", target: "TrainingEnhancements" },
    { level: "h2", title: "Circuit Extraction", target: "CircuitExtraction" },
    { level: "h3", title: "Feature Pruning", target: "FeaturePruning" },
    { level: "h2", title: "Analysis", target: "Analysis" },
    { level: "h3", title: "Token Predictions", target: "TokenPredictions" },
    { level: "h3", title: "Feature Interactions", target: "FeatureInteractions" },
    { level: "h3", title: "Token Embeddings", target: "TokenEmbeddings" },
    { level: "h2", title: "Applications", target: "Applications" },
    { level: "h3", title: "Debugging", target: "Debugging" },
    { level: "h3", title: "Dataset Analysis", target: "DatasetAnalysis" },
    { level: "h3", title: "Safety Analysis", target: "SafetyAnalysis" },
    { level: "h2", title: "Roadmap", target: "Roadmap" },
  ];

  const scrollIntoView = (targetId: string) => {
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div id="OutlineV1">
      <h1>Outline</h1>
      {sections.map((section, index) => {
        const Tag = section.level as keyof JSX.IntrinsicElements;
        return (
          <Tag key={index} onClick={() => scrollIntoView(section.target)}>
            {section.title}
          </Tag>
        );
      })}
    </div>
  );
}

export { Outline };
